import { Theme } from '@mui/material/styles'

const muiDialogTitle = (_theme: Theme) => {
  return {
    styleOverrides: {
      root: {
        padding: '1.25rem',
        fontSize: '1.125rem',
        fontWeight: 600
      }
    }
  }
}

export default muiDialogTitle
